import { useEffect, useId } from 'react'
import { useUnsavedChangesStore } from '@/store/unsavedChangesStore'

const { register, unregister } = useUnsavedChangesStore.getState()

export function useUnsavedChangesProcessing(isDirty: boolean) {
  const id = useId()

  useEffect(() => {
    if (isDirty) {
      register(id)
    } else {
      unregister(id)
    }
  }, [isDirty, id])

  // Always unregister on unmount (handles cases where component unmounts
  // while still dirty, e.g. navigating away after blocker.proceed())
  useEffect(() => {
    return () => unregister(id)
  }, [id])
}
